import React from 'react';

const QuienesSomosIndustrial: React.FC = () => {
  return (
    <section id="quienes-somos" className="section-industrial quienes-somos-industrial">
      <div className="quienes-somos-container">        
        <div className="info-blocks-grid">
          <div className="info-block block-large">
            <div className="block-header">
              <span className="block-number">01</span>
              <h3>NUESTRA EMPRESA</h3>
            </div>
            <div className="block-content">
              <p>
                Somos una empresa especializada en el <strong>alquiler y operación de 
                unidades sanitarias portátiles</strong> para eventos de diversa magnitud, 
                tanto masivos como privados.
              </p>
              <p>
                Nos distinguimos no solo por la prestación del servicio de arrendamiento, 
                sino por ofrecer una <strong>solución integral</strong> en materia de 
                infraestructura sanitaria y atención al usuario.
              </p>
            </div>
          </div>
          
          <div className="info-block block-medium">
            <div className="block-header">
              <span className="block-number">02</span>
              <h3>NUESTRO COMPROMISO</h3>
            </div>
            <div className="block-content">
              <p>
                Garantizamos unidades en <strong>óptimas condiciones</strong>, equipadas 
                con los insumos necesarios y respaldadas por un equipo de profesionales 
                altamente capacitados.
              </p>
              <div className="commitment-highlights">
                <div className="highlight-item">
                  <span className="highlight-icon">🏆</span>
                  <span>Altos estándares de higiene</span>
                </div>
                <div className="highlight-item">
                  <span className="highlight-icon">⚡</span>
                  <span>Máxima eficiencia</span>
                </div>
                <div className="highlight-item">
                  <span className="highlight-icon">🎯</span>
                  <span>Experiencia superior</span>
                </div>
              </div>
            </div>
          </div>

          <div className="info-block block-medium">
            <div className="block-header">
              <span className="block-number">03</span>
              <h3>EQUIPOS DISPONIBLES</h3>
            </div>
            <div className="block-content">
              <p>
                Disponemos de una <strong>amplia variedad</strong> de equipos 
                sanitarios portátiles de última generación:
              </p>
              <ul className="equipment-list">
                <li>
                  <span className="equipment-icon">🚿</span>
                  <span>Duchas portátiles</span>
                </li>
                <li>
                  <span className="equipment-icon">🚽</span>
                  <span>Baños portátiles</span>
                </li>
                <li>
                  <span className="equipment-icon">🚰</span>
                  <span>Lavamanos externos</span>
                </li>
                <li>
                  <span className="equipment-icon">🔧</span>
                  <span>Equipos especializados</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="info-block block-large">
            <div className="block-header">
              <span className="block-number">04</span>
              <h3>SERVICIO TÉCNICO ESPECIALIZADO</h3>
            </div>
            <div className="block-content">
              <p>
                Ofrecemos un <strong>servicio especializado de mantenimiento</strong> 
                para las unidades portátiles, llevado a cabo mediante vehículos tipo 
                vactor y sistemas de lavado a presión.
              </p>
              <div className="service-features">
                <div className="feature-section">
                  <h4>🧪 INSUMOS BIODEGRADABLES</h4>
                  <div className="feature-grid">
                    <div className="feature-item">
                      <span className="feature-bullet">◈</span>
                      <span>Papel higiénico premium</span>
                    </div>
                    <div className="feature-item">
                      <span className="feature-bullet">◈</span>
                      <span>Bolsas para residuos</span>
                    </div>
                    <div className="feature-item">
                      <span className="feature-bullet">◈</span>
                      <span>Agente químico biodegradable</span>
                    </div>
                  </div>
                </div>
                <div className="feature-section">
                  <h4>🌱 COMPROMISO AMBIENTAL</h4>
                  <div className="feature-grid">
                    <div className="feature-item">
                      <span className="feature-bullet">◈</span>
                      <span>Descomposición de materia orgánica</span>
                    </div>
                    <div className="feature-item">
                      <span className="feature-bullet">◈</span>
                      <span>Eliminación y prevención de malos olores</span>
                    </div>
                    <div className="feature-item">
                      <span className="feature-bullet">◈</span>
                      <span>Mitigación de riesgos ambientales</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QuienesSomosIndustrial;